export default {
    title: 'Create Product',
    editTitle: 'Edit Product',
    successEditMessage: 'Product updated successfully',
    backLink: 'Back to products',
    button: {
        add: 'Add Product',
        update: 'Update Product',
        cancel: 'Cancel',
        confirm: 'Confirm'
    },
    details: {
        title: 'Product details',
        productTitle: {
            title: 'Title',
            placeholder: 'Enter title'
        },
        productCategory: {
            title: 'Category',
            placeholder: 'Choose category'
        },
        productSubcategory: {
            title: 'Subcategory',
            placeholder: 'Choose subcategory'
        },
        productCode: {
            title: 'Product code',
            placeholder: 'Enter product code'
        },
        productDescription: {
            title: 'Description',
            placeholder: 'Enter product description'
        },
        productSpecs: {
            title: 'Specifications (optional)',
            placeholder: 'Enter product specifications'
        },

        barcode: {
            title: 'Barcode',
            placeholder: 'Enter barcode'
        },
        button: 'Add more description'
    },
    gallery: {
        title: 'Gallery',
        idealAspectRatio: 'Ideal aspect ratio is',
        tooltip: 'The first image in the gallery must be a clear image of the product in close-up.'
    },
    price: {
        title: 'Product price',
        productPrice: {
            title: 'Price'
        },
        productVAT: 'VAT is included in the price of the product',
        onDiscount: 'Is product on discount?'
    },
    quantity: {
        title: 'Product quantity',
        quantity: 'Quantity available',
        available: 'Available',
        continueSale: 'Continue with sale after stocks run out'
    },
    vat: "VAT",
    inBulk: 'In bulk',
    variants: {
        title: 'Product variants',
        hasVariants: 'Product has variants',
        delete: 'Remove',
        weightUnitPlaceholder: 'unit',
        defaultPrice: 'Default Price',
        defaultProductCode: 'Default Product Code',
        overview: {
            title: 'Variants Overview',
            editOptions: 'Edit Options',
            addVariant: 'Add Variant',
            addNewOption: 'Add new option',
            variant: 'Variant',
            price: 'Price',
            comparePrice: 'Compare at price',
            quantity: 'Quantity',
            sku: 'SKU',
            barcode: 'Barcode',
            edit: 'Edit',
            delete: 'Delete variant',
            modalTitle: 'Edit Variant',
            modal: {
                editVariant: {
                    title: 'Edit Variant'
                },
                addVariant: {
                    title: 'Add Variant'
                }
            },
            deletedMessage: 'This variant will not be created',
            undo: 'Undo',
            existsErrorShort: 'Variant with these option values already exists.',
            existsError: 'Variant with these option values already exists. Please change at least one option value.'
        },
        addOption: {
            title: 'Add New Option',
            option: 'Option',
            defaultOptionValue: 'Default Option Value',
            info: "Variants that already exist will have this value for the new option",
            buttons: {
                close: 'Close',
                save: 'Save'
            }
        },
        option: 'Option',
        options: 'Values for option',
        button: 'Add another variant',
        info: "In order to create a variant we have to add options for it. " +
            "For example, if we add option Color and values for it red and black and then we add option " +
            "Size and values S and M we will have 4 variants: red S, red M, black S, black M. " +
            "We don't need to have variants for all options, we can delete some of them.",
        optionsInfo: "If you want to add new option values you can add them in \"Add Variant\" modal.",
        addOptionValuesInfo: "If you want to add a new option value type in value name in option's select field and press enter.",
        cannotBeRemoved: "Variant with this option value is connected with order or cart so is can't be removed at the moment.",
        warning: "Warning!"
    },
    deliveries: {
        title: 'Surcharge',
        deliversToCities: 'For some municipalities a surcharge is paid.',
        price: 'Price',
        municipality: 'Municipality',
        button: 'Add another municipality'
    },
    delivery: {
        title: 'Delivery',
        isPhysical: 'This is a physical product',
        description:
            'Customers will not enter shipping address or choose a shipping method when purchasing this product.',
        weight: 'Weight',
        deliveryDays: 'Estimated shipping days'
    },
    searchEngine: {
        title: 'Search engine listing preview',
        edit: 'Edit website SEO',
        pageTitle: {
            title: 'Page title',
            placeholder: 'Short sleeve T-shirt'
        },
        description: {
            title: 'Description',
            placeholder: 'Enter page description'
        },
        urlHandle: {
            title: 'URL and handle',
            placeholder: 'Enter URL here'
        },
        of: 'of',
        slug: 'product-name',
        charactersUsed: 'characters used',
        metaTitleInfo: 'Page title refers to the title of a product page that is displayed both in Search Engine result snippets as well as the page\'s tab in browsers.',
        metaDescriptionInfo: 'Description is used for describing and summarizing the contents of your page for the benefit of users and Search Engines.'
    },
    activity: {
        title: 'Activity',
        status: 'The product is active.',
        status2: 'The product is not active.',
        statusActiveEdit: "Proizvod je objavljen.",
        description:
            'Active products are visible in the store. The activity of the product can change even after its addition',
        planPublishing: 'Plan your publishing time',
        date: {
            title: 'Date',
            placeholder: 'Choose date'
        }
    },
    organization: {
        title: 'Organization',
        description: "If brand/tag doesn't already exist in database type in its name and you will see an option to save it.",
        vendor: {
            title: 'Brand',
            question:
                'Adding a new vendor is recommended only if the vendor does not already exist in the database.'
        },
        collection: {
            title: 'Collections',
            description: 'Add a product to your collection to make it easier to find in your store.'
        },
        tags: {
            title: 'Tags',
            question:
                'Adding a new tag is recommended only if the tag does not already exist in the database.'
        }
    }
};
